export default "__VITE_ASSET__BogRCSvp__"